export const SvgStar = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 0L7.89222 4.10778L12 6L7.89222 7.89222L6 12L4.10778 7.89222L0 6L4.10778 4.10778L6 0Z" fill="#3A8EF6" />
  </svg>
);